import { cn } from '@/lib/utils';

type AcesLogoProps = {
  className?: string;
};

/** Logo em /public/icons — SVG com viewBox correto e traços brancos para o hero escuro. */
export function AcesLogo({ className }: AcesLogoProps) {
  return (
    <img
      src="/icons/aceslogo.svg"
      alt="Aces"
      className={cn(
        'block h-11 w-auto max-w-[min(100%,13rem)] object-contain object-left md:h-14 md:max-w-[16rem] lg:h-16 lg:max-w-[18rem]',
        className
      )}
      decoding="async"
    />
  );
}
